import { FC, ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { LangKey } from '@airwallex/global';

import { useThemeData } from '@/providers/themeDataProvider';
import { ThemedBrandingShell, deriveBrandingSettings } from '@/providers/themedBrandingShell';

interface AppThemeShellProps {
  children: ReactNode;
}

// Reads merchant theme from StoreContext and applies the RFC-252 override.
// Passes through with baseline theme while themeData is null (pre-fetch).
export const AppThemeShell: FC<AppThemeShellProps> = ({ children }) => {
  const { themeData } = useThemeData();
  const {
    i18n: { language },
  } = useTranslation();

  const brandingSettings = useMemo(() => deriveBrandingSettings(themeData), [themeData]);

  return (
    <ThemedBrandingShell
      seedColors={themeData?.seedColors}
      brandingSettings={brandingSettings}
      langKey={language as LangKey}
    >
      {children}
    </ThemedBrandingShell>
  );
};
